var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2146 11.1406H15.786C15.2732 11.1406 14.8574 11.5564 14.8574 12.0692V23.2121C14.8574 23.7249 15.2732 24.1406 15.786 24.1406H23.2146C23.7274 24.1406 24.1431 23.7249 24.1431 23.2121V12.0692C24.1431 11.5564 23.7274 11.1406 23.2146 11.1406Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2146 1.08203H15.786C15.2732 1.08203 14.8574 1.49777 14.8574 2.0106V5.74346C14.8574 6.2563 15.2732 6.67203 15.786 6.67203H23.2146C23.7274 6.67203 24.1431 6.2563 24.1431 5.74346V2.0106C24.1431 1.49777 23.7274 1.08203 23.2146 1.08203Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5232 1.08203H3.09459C2.58175 1.08203 2.16602 1.49777 2.16602 2.0106V13.1535C2.16602 13.6663 2.58175 14.082 3.09459 14.082H10.5232C11.036 14.082 11.4517 13.6663 11.4517 13.1535V2.0106C11.4517 1.49777 11.036 1.08203 10.5232 1.08203Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.5232 18.5508H3.09459C2.58175 18.5508 2.16602 18.9665 2.16602 19.4794V23.2122C2.16602 23.725 2.58175 24.1408 3.09459 24.1408H10.5232C11.036 24.1408 11.4517 23.725 11.4517 23.2122V19.4794C11.4517 18.9665 11.036 18.5508 10.5232 18.5508Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.882ab0845b090be4bfd5718543403aab.svg";
export { ForwardRef as ReactComponent };